(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairExhibitorsPremiumBoothsController', PhysicalFairExhibitorsPremiumBoothsController);

    PhysicalFairExhibitorsPremiumBoothsController.$inject = ['ExpoService', 'CitiesByExpoService', 'ExhibitorsService'];

    function PhysicalFairExhibitorsPremiumBoothsController(ExpoService, CitiesByExpoService, ExhibitorsService) {
        
        var vm = this;
        vm.activate             = activate;
        vm.getExpos             = getExpos;
        vm.expoSelected         = '';
        vm.selectCitiesByExpo   = selectCitiesByExpo;
        vm.citySelected         = '';
        vm.getByFilter          = getByFilter;
        vm.flag                 = false;

        function activate () {
            vm.getExpos();
        }

        function getExpos () {
            ExpoService.getExpos().then(function(response) {
                vm.expos = response.data;
            });
        }

        function selectCitiesByExpo () {
            CitiesByExpoService.getCities(vm.expoSelected).then(function(response){
                vm.cities = response.data;
            });
        }

        function getByFilter () {
            vm.flag     = false;
            let query   = {};
            query['expo_id'] = vm.expoSelected;
            if(vm.citySelected != '') {
                query['expo_location_id'] = vm.citySelected;
            }
            ExhibitorsService.getPremiumBooths(query).then(function(response) {
                vm.exhibitors   = response.data;
                vm.flag         = true;
            });
        }

        vm.activate();
    }
})();
